// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__1_oS7","loading_display":"PageLoading_loading_display__23Xy6","spin":"PageLoading_spin__39YNV"};